import { render, staticRenderFns } from "./SSOWaiting.vue?vue&type=template&id=90e98edc&"
import script from "./SSOWaiting.vue?vue&type=script&lang=js&"
export * from "./SSOWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports